// extracted by mini-css-extract-plugin
export var wordContainer = "_pq-0";